/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const dragIcon = ({size, ...props}) => (
  <svg viewBox="0 0 1000 1000" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M290 80c0 38.7 31.3 70 70 70 38.7 0 70-31.3 70-70s-31.3-70-70-70C321.3 10 290 41.3 290 80zM570 80c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70S570 41.3 570 80zM290 360c0 38.7 31.3 70 70 70 38.7 0 70-31.3 70-70s-31.3-70-70-70C321.3 290 290 321.3 290 360zM570 360c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70S570 321.3 570 360zM290 640c0 38.7 31.3 70 70 70 38.7 0 70-31.3 70-70s-31.3-70-70-70C321.3 570 290 601.3 290 640zM570 640c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70S570 601.3 570 640zM290 920c0 38.7 31.3 70 70 70 38.7 0 70-31.3 70-70 0-38.7-31.3-70-70-70C321.3 850 290 881.3 290 920zM570 920c0 38.7 31.3 70 70 70s70-31.3 70-70c0-38.7-31.3-70-70-70S570 881.3 570 920z"
    />
  </svg>
);
dragIcon.displayName = 'dragIcon';
dragIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
